module.exports = __webpack_public_path__ + "img/lkk.b6b77c05.svg";